import {customThemeConstants} from '@hconnect/uikit/src/lib2'

type Props = {
  path: string
  inactive?: boolean
}

export const CountryBorders = ({path, inactive}: Props) => {
  return (
    <path
      d={path}
      fill={customThemeConstants().palette.mapAreaFill}
      stroke={customThemeConstants().palette.mapAreaStroke}
      strokeWidth={2}
      fillOpacity={inactive ? 0.1 : 1}
    />
  )
}
